const allImages = {
  authOverlay: require("./images/auth-overlay-image.png"),
  b2bImage: require("./images/b2b-image.png"),
  clientImage: require("./images/client-image.png"),
  uploadImage: require("./images/upload-image-dumy.png"),
  uploadDumyImage: require("./images/upload-dumy-image.png"),
  shopImage: require("./images/shop-image.png"),
  dumyMen1: require("./images/dumymen1.jpg"),
  dumyMen2: require("./images/dumymen2.jpg"),
  dumyMen3: require("./images/dumymen3.jpg"),
  dumyMen4: require("./images/dumymen4.jpg"),
  welcomeImage: require("./images/welcome-image.png"),
  landingHomeBgImage: require("./images/landing-home-bg-image.png"),
  landingHomeLineImage: require("./images/landing-home-line-image.png"),
  landingHomeDbcover: require("./images/landing-home-dbcover.png"),
  landingSpaImage1: require("./images/landing-spa-image-1.png"),
  landingSpaImage2: require("./images/landing-spa-image-2.png"),
  landingSpaImage3: require("./images/landing-spa-image-3.png"),
  landingCurveLine: require("./images/landing-curve-line.png"),
  landingManageWebsite: require("./images/landing-manage-web-image.png"),
  landingManageMobile: require("./images/landing-manage-mobile-image.png"),
  productImg: require("./images/productImg.png"),
  dumyUserImg: require("./images/dumy-user-img.png"),
  // mobile page
  landingMobileMain: require("./images/landing-mobile-main-image.png"),
  appStoreBtn: require("./images/app-store-btn-image.png"),
  playStoreBtn: require("./images/play-store-btn-image.png"),
  landingJoinviadb: require("./images/landing-mobile-joindb-image.png"),
  landingMobileBb2: require("./images/landing-mobile-b2b-image.png"),
  landingMobileOnline: require("./images/landing-mobile-online-image.png"),
  // about us
  landingAboutusMain: require("./images/landing-about-us-image.png"),
  landingAboutUsVimage: require("./images/landing-about-vimage.png"),
  image: require("./images/img.png"),

  //New website
  joinUsbBg: require("./images/authentication-bg.png"),
  authBgImg: require("./images/auth-bg.png"),
  appStoreBtnImg: require("./images/appstore-btn-img.png"),
  playStoreBtnImg: require("./images/play-store-btn.png"),
  houseCleaninImg: require("./images/house-cleanser-img.png"),
  cheafCookingImg: require("./images/cheaf-cooking-img.png"),
  poolCLeaningImg: require("./images/pool-cleaning-img.png"),
  laundaryCLeaningImg: require("./images/laundary-cleaning-img.png"),
  carCLeaningImg: require("./images/car-washing-img.png"),
  teacherSignature: require("./images/teachure-signature.png"),
  authMainBgImg: require("./images/auth-bg-img.png"),
  acceptImage: require("./images/accept-img.png"),
};

const allIcons = {
  // social icoms
  googleIcon: require("./icons/google-icon.png"),
  linkedinIcon: require("./icons/linkedin-icon.png"),
  // Navbar icons
  dasboardActice: require("./icons/dashboard-active-icon.png"),
  dasboardInactice: require("./icons/dashboard-icon-inactive.png"),
  bookopenActive: require("./icons/BookOpen-active-icon.png"),
  bookopenInactive: require("./icons/BookOpen-icon-inactive.png"),
  smileyActive: require("./icons/Smiley-active-icon.png"),
  smileyInactive: require("./icons/smiley-icon-inactive.png"),
  notificationActive: require("./icons/notification-icon.png"),
  notificationInactive: require("./icons/notification-icon-inactive.png"),
  reportIconActive: require("./icons/report-active-icon.png"),
  reportIconInactive: require("./icons/report-icon-inactive.png"),
  packageIconActive: require("./icons/package-active-icon.png"),
  packageIconInactive: require("./icons/package-inactive-icon.png"),
  settingActiveIcon: require("./icons/settings-active-icon.png"),
  settingInactiveIcon: require("./icons/settings-inactive-icon.png"),
  handshakeActiveIcon: require("./icons/handshake-active-icon.png"),
  handshakeInactiveIcon: require("./icons/handshake-inactive-icon.png"),
  saleActiceIcon: require("./icons/sale-active-icon.png"),
  saleInacticeIcon: require("./icons/sale-inactive-icon.png"),
  teamActiveIcon: require("./icons/team-active-icon.png"),
  teamInactiveIcon: require("./icons/team-inactive-icon.png"),
  onlineProfileActiveIcon: require("./icons/online-profile-active-icon.png"),
  onlineProfileInactiveIcon: require("./icons/user-square-profile-inactive.png"),
  calendarCheckActiveIcon: require("./icons/calendar-check-active-icon.png"),
  branchActiveIcon: require("./icons/branch-active-icon.png"),
  branchInactiveIcon: require("./icons/branch-inactive-icon.png"),
  // Other Icons
  cardIcon: require("./icons/card-icon.png"),
  trashIcon: require("./icons/trash-icon.png"),
  exportIcon: require("./icons/export-icon.png"),
  deleteIcon: require("./icons/delete-icon.png"),
  editIcon: require("./icons/edit-icon.png"),
  editFillIcon: require("./icons/edit-fill-icon.png"),
  calenderIcon: require("./icons/calender-icon.png"),
  loginIcon: require("./icons/SignIn-icon.png"),
  searchIcon: require("./icons/search-icon.png"),
  filterIcon: require("./icons/Shower-icon.png"),
  backIcon: require("./icons/back-icon.png"),
  rightArrowIcon: require("./icons/right-arrow-icon.png"),
  arrowDownIcon: require("./icons/arrow-down-icon.png"),
  homeIcon: require("./icons/house-icon.png"),
  statusIcon: require("./icons/status-icon.png"),
  checkSquareIcon: require("./icons/check-square-icon.png"),
  uncheckSquareIcon: require("./icons/square-uncheck-icon.png"),
  sendIcon: require("./icons/send-icon.png"),
  settingIcon: require("./icons/setting-icon.png"),
  logoutIcon: require("./icons/log-out-icon.png"),
  boundyBoxIcon: require("./icons/bounding-box-icon.png"),
  briefcaseIcon: require("./icons/briefcase-icon.png"),
  minimizeIcon: require("./icons/minimize-icon.png"),
  calendarGreyIcon: require("./icons/calendar-grey-icon.png"),
  conformIcon: require("./icons/confirm-icon.png"),
  dumyUserIcon: require("./icons/dumy-user-icon.png"),
  mapIcon: require("./icons/map-icon.png"),
  chartPieSliceIcon: require("./icons/chartpieslice-icon.png"),
  notificatioHeaderIcon: require("./icons/notification-header-icon.png"),
  calenderCheckIcon: require("./icons/calendar-check-icon.png"),
  chatIcon: require("./icons/chat-circle-text-icon.png"),
  circleHalfIcon: require("./icons/circle-half-icon.png"),
  checkCicleInactive: require("./icons/circle-check-inactive.png"),
  phoneOutgoingIcon: require("./icons/phone-outgoing-icon.png"),
  googleLogoIcon: require("./icons/google-logo-icon.png"),
  chatWhiteIcon: require("./icons/chat-white-icon.png"),
  locationIcon: require("./icons/location-icon.png"),
  checkInactiveCircle: require("./icons/check-inactive-circle.png"),
  crossBoldIcon: require("./icons/cross-bold-icon.png"),
  halfstar: require("./icons/halfstar.png"),
  //landing pages
  playVideoIcon: require("./icons/play-video-icon.png"),
  landingView1: require("./icons/landing-view-icon-1.png"),
  landingView2: require("./icons/landing-view-icon-2.png"),
  landingView3: require("./icons/landing-view-icon-3.png"),
  landingView4: require("./icons/landing-view-icon-4.png"),
  landingView5: require("./icons/landing-view-icon-5.png"),
  microphoneIcon: require("./icons/landing-home-microphone.png"),
  mobilephoneIcon: require("./icons/landing-home-mobile.png"),
  hourIcon: require("./icons/landing-home-24.png"),
  landingBagIcon: require("./icons/landing-home-gr-bag.png"),
  landingAlarmIcon: require("./icons/alram-icon.png"),
  landingDashboardIcon: require("./icons/landing-home-gr-dp.png"),
  landingLiveChatIcon: require("./icons/landing-home-gr-livechat.png"),
  landingTagIcon: require("./icons/landing-home-gr-tag.png"),
  landingBookIcon: require("./icons/landing-home-gr-book.png"),
  landingBagColorIcon: require("./icons/landing-home-gr-bag-color.png"),
  landingAlarmColorIcon: require("./icons/alarm-color-icon.png"),
  landingDashboardColorIcon: require("./icons/landing-home-gr-db-color.png"),
  landingLiveChatColorIcon: require("./icons/landing-home-gr-livecharcolor.png"),
  landingTagColorIcon: require("./icons/landing-home-gr-tagcolor.png"),
  landingBookColorIcon: require("./icons/landing-home-gr-bookcolor.png"),
  // social icons
  youtubeSocialIcon: require("./icons/youtube-social-icon.png"),
  facebookSocialIcon: require("./icons/facebook-social-link.png"),
  twitterSocialIcon: require("./icons/twitter-social-icon.png"),
  instagramSocialIcon: require("./icons/instagram-social-icon.png"),
  linkdinSocialIcon: require("./icons/linkdin-social-icon.png"),

  googlePlayLogo: require("./icons/google-play-logo.png"),
  appStoreLogo: require("./icons/apple-white-icon.png"),

  landingHeadphoneIcon: require("./icons/landing-headphone-icon.png"),
  whatsAppLogoColor: require("./icons/whats-app-logo-color.png"),
  telegramLogoColor: require("./icons/telegram-logo.png"),
  Question: require("./icons/Question.png"),
  calendarWhiteIcon: require("./icons/calendar-white-icon.png"),
  statusDropDownIcon: require("./icons/status-drop-icon.png"),
  admissionBlackIcon: require("./icons/admission-black-icon.png"),
  admissionWhiteIcon: require("./icons/Admission-white-icon.png"),
  checkRectangeIcon: require("./icons/check-rectange-icon.png"),
  uncheckRectangeIcon: require("./icons/uncheck-rectangle-icon.png"),
  studentActiveIcon: require("./icons/ed-eduction-whiteIcon.png"),
  studentInActiveIcon: require("./icons/ed-eduction-blackIcom.png"),
  classBlackIcon: require("./icons/class-black-icon.png"),
  classWhiteIcon: require("./icons/class-white-icon.png"),
  timerBlackIcon: require("./icons/time-black-icon.png"),
  cashBundleBlackIcon: require("./icons/cash-bundle-black-icon.png"),
  timeTableBlackIcon: require("./icons/time-table-black-icon.png"),
  timeTableWhiteIcon: require("./icons/time-table-white-icon.png"),
  reportCardBlackIcon: require("./icons/report-card-black-icon.png"),
  reportCardWhiteIcon: require("./icons/report-card-white-icon.png"),
};

const appLogo = {
  mainLogo: require("./icons/Group 1000004517.png"),
  schoologo: require("./images/school-logo-img.png"),
  eazidayLogo: require("./images/service-provider-logo.png"),
  eazidayLogoNew: require("./images/service-provider-logo-new.png"),
};

const appFonts = {
  Roboto: "Roboto",
  Poppins: "Poppins",
};

const appGifs = {
  blueLoading: require("./gifs/blue-loading.gif"),
};

export { allImages, allIcons, appLogo, appFonts, appGifs };
